import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';

import { ApiOrdMethod } from 'src/app/api/api-methods.ord';
import { Injectable, inject } from '@angular/core';
import { OrdSearchActions } from './ord-search.actions';
import { OrdSearchI } from 'src/app/api/ord-search/ord-search.result.int';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { Store } from '@ngrx/store';
import sharedEnvironmentReducer from '../shared-environment-info/shared-environment-info.reducer';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class OrdSearchEffects {
    private readonly store = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericSerivce = inject(SharedGenericService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdSearchActions.load),
        withLatestFrom(this.store.select(sharedEnvironmentReducer.selectUsername)),
        switchMap(([action, username]) => from(this.sharedGenericSerivce.invoke(ApiOrdMethod.ordSearch, { ...action.query, username }))
            .pipe(
                map((result: OrdSearchI) => OrdSearchActions.received({
                    result
                })),
                catchError((error) => {
                    console.error(error);
                    return [
                        OrdSearchActions.error({
                            error: error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            ))
    ));

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdSearchActions.load),
        mergeMap(() => [
            // spf.spinner.SHOW({
            // }),
        ]))
    );

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdSearchActions.error),
        mergeMap(() => [
            // spf.spinner.HIDE({
            // }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(OrdSearchActions.received),
        mergeMap(() => [
            // spf.spinner.HIDE({
            // }),
        ]))
    );
}
